<template>
  <main class="main page-inside text-page faq-page">
    <div class="main-wrapper">
      <div class="section hero-section">
        <img src="./../img/hero.jpg" class="bg"/>
        <div class="wrapper home">
          <div class="title big">FAQ</div>
        </div>
      </div>
      <section class="section store-section">
        <img src="./../img/section6.svg" class="bg"/>
        <transition name="fade">
          <div class="wrapper">
            <div class="accordion">
              <div class="item" v-for="(item, index) in faq" :key="index">
                <div class="panel" @click="togglePanel(index)">
                  <div v-if="isActivePanel(index)" class="minus"></div>
                  <div v-else class="plus"></div>
                  <div class="title" v-html="$parent.wrapFirstLetterInSpan(item.title)"/>
                </div>
                <Transition name="slide">
                  <div class="panel-desc desc desc-main" v-if="isActivePanel(index)">
                    {{ item.content }}
                  </div>
                </Transition>
              </div>
            </div>
          </div>
        </transition>
      </section>
      <div class="section store-section-2">
        <img src="./../img/section7.png" class="bg"/>
        <div class="wrapper">
          <div class="title small server-status"><span>S</span>ERVER <span>S</span>TATUS: <span class="green">ONLINE</span></div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>

export default {
  name: 'TextPage',
  props: [],
  components: {
  },
  data: function() {
    return {
      faq: [],
      activePanels: [],
    }
  },
  mounted: async function() {
    await Promise.all([this.getFaq()]);
  },
  methods: {
    togglePanel(index) {
      if (this.isActivePanel(index)) {
        this.activePanels.splice(this.activePanels.indexOf(index), 1)
      } else {
        this.activePanels.push(index)
      }
    },
    isActivePanel(index) {
      return this.activePanels.includes(index)
    },
    getFaq() {
      return this.$http.get(process.env.VUE_APP_API + 'faq')
          .then((res) => {
            this.faq = res.data.payload.map(({question, answer}) => ({
              title: question,
              content: answer
            }));
          })
          .catch(() => {})
    },
  }
}
</script>